import Vue from "vue";
import $ from "jquery";
import Component from "vue-class-component";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";
import { EventBus } from "../../Controls/EventBus";
import { ModalSalariesOptions } from "../modalSalaries/modalSalaries";
import EventConstants from "../../Controls/EventConstants";
import { ContratAEditerDto } from "../../../dto/GenApi.iNotPaie.Dto/ContratAEditerDto";
import { DemandeEditionsPaieDto } from "../../../dto/GenApi.iNotPaie.Dto/DemandeEditionsPaieDto";
import { NotificationServiceInstance } from "../../../shared/services/notification.service";

@Component
export default class modalReeditionBulletins extends Vue {
	public moisDebut = 0;
	public anneeDebut = 0;
	public moisFin = 0;
	public anneeFin = 0;
	public typeEdition = "G";
	public typeBulletin = "Simplifie";
	public dataReady = false;
	public salaries: ContratAEditerDto[] = [];

	public init(): void {
    	$("#modalReeditionBulletins").modal("show");
    	this.typeBulletin = "Simplifie";
    	ServicesFactoryInstance.ExercicesService.getDernierExercice(data => {
    		this.anneeDebut = this.anneeFin = data.Annee;
    		this.moisDebut = this.moisFin = data.Mois;
    	});
	}

	public lancerReedition(listIdContrat: number[]): void {
    	const demande: DemandeEditionsPaieDto = {
    		IdContrats: listIdContrat,
    		AncienFormat: (this.typeBulletin === "Ancien"),
    		Detaille: (this.typeBulletin === "Detaille"),
    		AnneeDebut: this.anneeDebut,
    		AnneeFin: this.anneeFin,
    		MoisDebut: this.moisDebut,
    		MoisFin: this.moisFin
    	};

    	NotificationServiceInstance.SendSuccess("La demande d'édition a été prise en compte. Le document sera bientôt disponible");

    	ServicesFactoryInstance.CalculPaieService.getBulletinsPdf(demande, (r: Blob) => {
    		if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    			window.navigator.msSaveOrOpenBlob(r, "bulletins de salaire.pdf");
    			this.dataReady = true;
    		} else {
    			this.dataReady = true;

    			const link = document.createElement("a");
    			document.body.appendChild(link);

    			link.href = window.URL.createObjectURL(r);
    			link.download = "bulletins de salaire.pdf";
    			link.click();

    			NotificationServiceInstance.SendSuccess("La réédition des bulletins s'est correctement déroulée !");
    		}
    	});
	}

	public valider(): void {
    	if (this.isDateDebutGreaterThanDateFin()) {
			return;
		}

    	ServicesFactoryInstance.CalculPaieService.GetContratAReediter(
    		this.anneeDebut, this.moisDebut, this.anneeFin, this.moisFin,
    		data => {
    			this.salaries = data;

    			if (this.typeEdition === "S") {
    				const modalOptions: ModalSalariesOptions = new ModalSalariesOptions({
    					moisDebut: this.moisDebut,
    					anneeDebut: this.anneeDebut,
    					moisFin: this.moisFin,
    					anneeFin: this.anneeFin,
    					yesText: "ÉDITER",
    					callBackYes: this.lancerReedition,
    					salaries: this.salaries
    				});

    				EventBus.$emit(EventConstants.MODAL_SALARIES, modalOptions);
    			} else if (this.typeEdition === "G") {
    				const listContrats: number[] = [];
    				for (let i = 0; i < this.salaries.length; i++) {
    					listContrats.push(this.salaries[i].IdContrat as number);
    				}
    				this.lancerReedition(listContrats);
    			}
    		});

    	this.closeModal();
	}

	public annuler(): void {
    	this.closeModal();
	}

	private closeModal(): void {
    	$("#modalReeditionBulletins").modal("hide");
	}

	private isDateDebutGreaterThanDateFin(): boolean {
    	const dateDebut = new Date(this.anneeDebut, this.moisDebut - 1);
    	const dateFin = new Date(this.anneeFin, this.moisFin - 1);
    	if (dateDebut > dateFin) {
    		NotificationServiceInstance.SendFailed("La date de fin doit être supérieur à la date de début");

    		return true;
    	}

    	return false;
	}
}



// WEBPACK FOOTER //
// ./src/components/modalComponents/modalReeditionBulletins/modalReeditionBulletins.ts